import React, { useState } from "react";
import { Card, Button, UncontrolledCollapse } from "reactstrap";
import "../CarLoanCalculator/NewCarLoan.scss";

function FAQs({ bgClorClass }) {
  const [open, setOpen] = useState();
  const [open1, setOpen1] = useState();
  const [open2, setOpen2] = useState();
  const [open3, setOpen3] = useState();
  const [open4, setOpen4] = useState();
  const [open5, setOpen5] = useState();

  return (
    <section className={`FAQs section-padding ${bgClorClass}`}>
      <div className="container pb-3">
        <div
          className="border rounded d-flex flex-wrap align-items-center justify-content-center bg-lightgrey mb-4"
          style={{ minHeight: 200 }}
        >
          <img className="w-100" src="/images/car-import-ads.jpg" alt="Car Import" />
        </div>
        <h2 className="mb-4 text-center text-primary">Frequently Asked Questions</h2>
        <div className="row">
          <div className="col-sm-6">
            <Button className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between" color="" id="toggler1" onClick={() => setOpen(!open)}>
              <div className="text-left">
                <h5 className="mb-0 text-primary">Can I import a 10-year-old car to Pakistan?</h5>
              </div>
              {open ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  Old and used vehicles that are no more than three years old, as well as other vehicles that are no more than five years old, can be imported.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between" color="" id="toggler2" onClick={() => setOpen1(!open1)}>
              <div className="text-left">
                <h5 className="mb-0 text-primary">Which cars cannot import for more than three years?</h5>
              </div>
              {open1 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open1 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  Hatchback, Sedan cars cannot import older than 3 years. But SUVs, commercial, and station wagons these cars can import older than 3 years but not more than 5 years.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between" color="" id="toggler3" onClick={() => setOpen2(!open2)}>
              <div className="text-left">
                <h5 className="mb-0 text-primary">Is an auction sheet important for car import?</h5>
              </div>
              {open2 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open2 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  The auction sheet is an assessment of Japanese cars which we buy. It can differentiate accidental or non-accidental cars.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between" color="" id="toggler4" onClick={() => setOpen3(!open3)}>
              <div className="text-left">
                <h5 className="mb-0 text-primary">Can we get an online record of imported cars?</h5>
              </div>
              {open3 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open3 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  Yes, it is possible to get an online record. You can verify 20 years old or above vehicle from its chassis number.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between" color="" id="toggler5" onClick={() => setOpen4(!open4)}>
              <div className="text-left">
                <h5 className="mb-0 text-primary">Is it difficult to import a vehicle from Japan?</h5>
              </div>
              {open4 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open4 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  While importing a vehicle from Japan may look to be a headache, the process is not that difficult. The simplest and most usual method is to locate an importer or company near your place that provides buyers with access to Japanese auction houses. You may then engage with them to locate a car that is perfect for you. So, you can choose autodeals
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
          <div className="col-sm-6">
            <Button className="px-0 py-4 border-bottom rounded-0 w-100 d-flex justify-content-between" color="" id="toggler6" onClick={() => setOpen5(!open5)}>
              <div className="text-left">
                <h5 className="mb-0 text-primary">What are risko/towing charges?</h5>
              </div>
              {open4 ? (
                <div className="px-3 text-secondary">
                  <i className="fas fa-times"></i>
                </div>
              ) : (
                <div className="px-3 text-secondary">
                  <i className="fas fa-plus"></i>
                </div>
              )}
            </Button>
            {open4 ? (
              <Card className="border-0 py-2 bg-transparent">
                <p className="text-muted">
                  All auction houses have websites where everyone can sell vehicles. So, we must keep in mind that the car location can be different from the auction house. Because the auction is online access. Further the distance of the car from the port, the more the charges may apply to the car these charges are known as risko/towing charges.
                </p>
              </Card>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
export default FAQs;